<script>
import { mapState } from 'vuex';
import Counters from '../../../lib/components/Fields/Counters.vue';
import FieldLabel from '../../../lib/components/Fields/FieldLabel.vue';
import ValidationErrors from '../../../lib/components/Fields/ValidationErrors.vue';
import HelpIcon from '../../../lib/components/Shared/HelpIcon.vue';

export default {
  inject: ['lang'],
  components: {
    Counters,
    HelpIcon,
    ValidationErrors,
    FieldLabel
  },
  props: {
    field: {
      type: Object,
      required: true
    },
    value: {
      type: [String, Number, Boolean, Array, Object],
      default: null
    },
    validationErrors: {
      type: Array,
      default: () => []
    },
    elementId: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapState('entryForm', ['isManager']),
    ...mapState('entryFormConfiguration', ['configurationMode']),
    displayCounters() {
      return (
        (this.field.type === 'text' || this.field.type === 'textarea') &&
        (!!this.field.maximumWords || !!this.field.maximumCharacters)
      );
    },
    displayLabel() {
      return this.field.type !== 'checkbox' && this.field.type !== 'content';
    },
    attribute() {
      return (this.field.label || '').toLowerCase();
    }
  }
};
</script>

<style scoped>
.controls {
  float: right;
  padding-left: 10px;
}
</style>
